var _path, _path2, _circle, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAzcl = function SvgAzcl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.813 7.875a1.5 1.5 0 0 1 1.5-1.5h5.625a1.5 1.5 0 0 1 1.5 1.5v2.48c1.084.312 2.119.739 3.092 1.266l1.743-1.743a1.5 1.5 0 0 1 2.121 0l3.978 3.977a1.5 1.5 0 0 1 0 2.122l-1.69 1.69a15.47 15.47 0 0 1 1.345 3.145h2.348a1.5 1.5 0 0 1 1.5 1.5v5.625a1.5 1.5 0 0 1-1.5 1.5h-2.24a15.465 15.465 0 0 1-1.319 3.28l1.556 1.556a1.5 1.5 0 0 1 0 2.121l-3.977 3.978a1.5 1.5 0 0 1-2.122 0l-1.502-1.502a15.464 15.464 0 0 1-3.334 1.4v2.105a1.5 1.5 0 0 1-1.5 1.5h-5.625a1.5 1.5 0 0 1-1.5-1.5V40.27a15.464 15.464 0 0 1-3.333-1.4l-1.502 1.502a1.5 1.5 0 0 1-2.122 0l-3.977-3.977a1.5 1.5 0 0 1 0-2.122l1.556-1.556a15.465 15.465 0 0 1-1.319-3.28h-2.24a1.5 1.5 0 0 1-1.5-1.5v-5.625a1.5 1.5 0 0 1 1.5-1.5h2.348c.333-1.105.787-2.159 1.344-3.146l-1.689-1.69a1.5 1.5 0 0 1 0-2.12l3.977-3.978a1.5 1.5 0 0 1 2.122 0l1.743 1.743a15.464 15.464 0 0 1 3.093-1.266v-2.48Z",
    fill: "url(#azcl_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.125 30.75a5.438 5.438 0 1 0 0-10.875 5.438 5.438 0 0 0 0 10.875Zm0 3.75a9.188 9.188 0 1 0 0-18.375 9.188 9.188 0 0 0 0 18.375Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.25,
    y: 11.25,
    width: 48.75,
    height: 48.75
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#azcl_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 12,
    cx: 35.625,
    cy: 35.625,
    r: 11.625,
    fill: "url(#azcl_svg__c)",
    stroke: "url(#azcl_svg__d)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 29.73a5.625 5.625 0 0 1 4.576 8.895l1.884 1.884a.925.925 0 0 1-1.307 1.307l-1.884-1.884a5.625 5.625 0 1 1-3.269-10.201Zm0 1.875a3.75 3.75 0 1 0 0 7.501 3.75 3.75 0 0 0 0-7.5Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azcl_svg__a",
    x1: 25.125,
    y1: 6.375,
    x2: 25.125,
    y2: 43.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azcl_svg__c",
    x1: 35.625,
    y1: 23.25,
    x2: 35.625,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azcl_svg__d",
    x1: 35.625,
    y1: 23.25,
    x2: 35.625,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1CCF9",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "azcl_svg__b",
    transform: "translate(-11.25 -11.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.625,
    cy: 35.625,
    r: 11.625
  })))));
};

export default SvgAzcl;